<template>
    <div style="background: #f4f4f4; padding-bottom: 40px">
        <div class="softMarketTop" v-if="goodsStatus==='SHELVE'">
            <div class="softMarketTopSearch">
                <div class="logoTitle">
                    <div class="logoTitle1">
                        水泵云商
                    </div>
                    <div class="logoTitle2">全部商品</div>
                </div>
                <div class="searchContainer">
                    <div class="flex searchContainerone">
                        <el-input
                                placeholder="请输入内容"
                                v-model="searchValue"
                                class="input-with-select"
                                @keyup.native.enter="getShopList"
                                prefix-icon="el-icon-search"
                        >
                            <el-button slot="append" @click="getShopList">
                                搜索
                            </el-button>
                        </el-input>
                        <button plain class="searchContainerButton" @click="toServiceAuthentication" v-if="isService">
                            商家入驻
                        </button>

                    </div>

                    <ul>
                        <li class="textLi" @click="searchByKeyword(items)" v-for="(items, index) in keywords">{{ items
                            }}
                        </li>
                    </ul>
                </div>
               <!-- <div class="shoppingCar" v-if="isShow">
                    <el-badge :value="goodsNum" class="item">
                        <el-button size="small" icon="el-icon-shopping-cart-full" @click="$router.push('/shopCar')">
                            我的购物车
                        </el-button>
                    </el-badge>
                </div>-->
            </div>
        </div>
        <div class="container" v-if="goodsStatus==='SHELVE'">
            <div class="flex" style="align-items: center;padding: 20px 0;color: #808080;font-size: 14px;">
                <span style="color: #808080">当前位置：</span>
      		    <el-breadcrumb separator="/">
				    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/mall' }">水泵云商</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/integralActivities/'+this.$route.query.activeUuid }"> 全部商品</el-breadcrumb-item>
                    <el-breadcrumb-item>商品详情</el-breadcrumb-item>
                </el-breadcrumb>
                <!-- <span>首页</span>
                 <span>></span>
                 <span>全部商品</span>
                 <span>></span>
                 <span style="color: #009999">商品详情</span> -->
            </div>
            <div class="containerStyleClass">
                <div class="containerLeftTop">
                    <div class="softwareLogo">
                        <div class="bigImg">
                            <el-carousel trigger="click" height="375px" arrow="always"
                                         @change="swiperChange" ref="carouselRef" :autoplay="false">
                                <!-- 视频播放 -->
                                <el-carousel-item v-if="urlInfo.length>0">
                                    <video-player class="video-player vjs-custom-skin"
                                                  ref="videoPlayer"
                                                  :playsinline="true"
                                                  :options="playerOptions"
                                                  style="height:385px"
                                    >
                                    </video-player>
                                </el-carousel-item>
                                <el-carousel-item v-for="(item,index) in pcGoodsImages" :key="index">
                                    <img :src="item.url" style="width: 100%;height: 100%;">
                                </el-carousel-item>
                                <el-carousel-item v-for="(item,index) in normsList" :key="pcGoodsImages.length+index">
                                    <img :src="item.filePath" style="width: 100%;height: 100%;">
                                </el-carousel-item>

                            </el-carousel>
                        </div>

                        <div class="goodsImgs">
                            <el-scrollbar style="height: 120px;width: 100%;" ref="thumbnailImgRef">
                                <ul ref="thumbnailImgUlRef">
                                    <!-- 图片 -->
                                    <li v-for="(item,index) in pcGoodsImages" v-if="pcGoodsImages.length>0"
                                        :key="index" :class="swiperIndex === index?'active':''"
                                        @click="thumbnailImgChange(index,1,item.url)"
                                        :style="pcGoodsImages.length === 4?index === 3?'margin-right: 0;':'margin-right: 9px;':'margin-right: 9px;'">
                                        <img :src="item.url" style="width: 140px; height: 90px">
                                    </li>
                                    <!-- 规格 -->
                                    <li v-for="(item,index) in normsList" v-if="normsList.length>0"
                                        :key="pcGoodsImages.length+index"
                                        :class="swiperIndex === pcGoodsImages.length+index?'active':''"
                                        @click="thumbnailImgChange(pcGoodsImages.length+index,2,item.filePath)"
                                        :style="(pcGoodsImages.length + normsList.length) === 4?pcGoodsImages.length+index === 3?'margin-right: 0;':'margin-right: 9px;':'margin-right: 9px;'">
                                        <img :src="item.filePath" style="width: 140px; height: 90px">
                                    </li>
                                </ul>
                            </el-scrollbar>
                        </div>
                    </div>
                    <div class="softwareRight">
                        <div class="topServBoxInfo">
                            <h3>{{ goodsInfo.name }}</h3>
                        </div>
                        <div class="flex topServBoxMess red">
                            <p style="
                text-decoration: line-through;
                font-size: 12px;
                color: #ccc;
              ">{{activityType=='INTEGRAL'?'':'¥'+goodsPrice}}</p>
                            <span>{{ price }}{{activityType=='INTEGRAL'?'积分':'元'}}</span>
                        </div>
                        <div class="flex goodsBests">
                            <p>选择规格：</p>
                            <div class="flex goodsListbox">
                                <div v-for="(item,index) in normsList" :key="index"
                                     v-model="specUuid"
                                     @click="change(index,item)"
                                     :class="changeBackground == index ? 'normsList1':'normsList'">
                                    <div>
                                        <img :src="item.filePath" alt="" style="width:50px;height:31px">
                                    </div>
                                    <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                                        <span>{{ item.name }}</span>
                                    </el-tooltip>
                                </div>
                            </div>
                        </div>
                        <div class="flex goodsBest">
                            <p>商城库存：</p>
                            <span v-if="totalNumber>0">{{ totalNumber }}{{ goodsInfo.unit }}</span>
                            <span v-else>无货</span>
                        </div>
                        <div class="flex goodsBest">
                            <p>商品成交量：</p>
                            <span>{{ volumeNum }}</span>
                        </div>
                        <div class="flex goodsBest"
                             v-if="totalNumber>0"
                             style="margin-bottom: 30px">
                            <p>购买数量：</p>
                            <el-input-number
                                    v-model="num"
                                    @change="handleChange"
                                    :min="1"
                                    :max="totalNumber"
                                    label="描述文字"
                            ></el-input-number>
                            <span style="margin-left: 15px">{{ goodsInfo.unit }}</span>
                        </div>
                        <div class="flex goodsBest"
                             v-if="totalNumber<=0"
                             style="margin-bottom: 30px">
                            <p>购买数量：</p>
                            <span>无货</span>
                        </div>
                        <div class="goodsButton flex">
                            <!--<el-button
                                    type="primary"
                                    style="width: 155px"
                                    plain
                                    icon="el-icon-shopping-cart-1"
                                    :disabled="showAddCar"
                                    @click="addShopCar"
                            >加入购物车
                            </el-button
                            >-->
                            <el-button type="primary" style="width: 140px"
                                       :disabled="showAddGoods"
                                       @click="rightBuy(goodsInfo.uuid,goodsInfo.brand)"
                            >立即兑换
                            </el-button
                            >
                            <div class="left_top_share flex">
                                <!-- <p v-show="collect">
                                    <i class="el-icon-star-on" style="color: #E6A23C;font-size: 24px;"
                                       @click="removeCollect"></i>
                                    <span>{{ goodsInfo.collectionVolume }}</span>
                                </p>
                                <p v-show="!collect" @click="saveCollect">
                                    <i class="el-icon-star-off"></i>
                                    <span>{{ goodsInfo.collectionVolume }}</span>
                                </p> -->
                                <p class="flex">
                                    <share :config="config" class="shareHover"
                                           style="font-size: 16px;line-height: 22px"></share>
                                </p>
                            </div>
                        </div>
                        <!-- <div class="goodsText">
                            <img :src="enterPriseInfo.logo ? enterPriseInfo.logo:require('../../assets/storeLogo.png') " alt="" style="width:60px">
                            <p>{{ enterPriseInfo.name ? enterPriseInfo.name :''}}</p>
                        </div>
                        <div>
                            <el-button type="primary" plain
                                       @click="goToDetail(storeInfo.enterpriseUuid)">进店逛逛
                            </el-button>
                            <el-button type="primary" plain @click="startChat(goodsInfo.createUserUuid)">立即联系
                            </el-button>
                        </div> -->
                    </div>
                </div>

                <div class="flex bottonMessage">
                    <div class="containerLeftBottom">
                        <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane label="商品详情" name="one" class="bottomMessage">
                                <span v-html="goodsInfo.pcDescription" class="vHtmlMess"></span>
                            </el-tab-pane>
                            <el-tab-pane label="规格描述" name="two" class="category">
                                <!-- <span>暂无信息</span> -->
                                <div class="category_box">
                                    <div class="categoryName">
                                        <p>规格名称：</p>
                                        <p>{{ categoryObj.name }}</p>
                                    </div>
                                    <!--<div class="categoryData">产品参数：</div>-->
                                    <div class="categoryMess">
                                        <div class="categoryMess_text"
                                             v-if="item.value"
                                             v-for="(item,index) in categoryObj.goodsSpecificationsOption">
                                            <p v-if="item.value.indexOf('000Z')>-1">{{ item.name }}：{{
                                                item.value.substring(0,10) }} {{item.unit}}</p>
                                            <p v-else>{{ item.name }}：{{ item.value=="[]"?"":item.value }}
                                                {{item.unit}}</p>
                                        </div>

                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="商品评价" name="three">
                                <div class="evaluationDetails" v-if="conmmentList.length != 0" v-loading="loading">
                                    <div class="flex right_sortbox">
                                        <p
                                                v-for="(items, index) in sortBox"
                                                :key="index"
                                                @click="getSortBox(index)"
                                                :class="sortboxIndex == index ? 'p_active' : ''">
                                            {{ items.name }} ({{ items.num }})
                                        </p>
                                    </div>
                                    <div v-for="(items, index) in conmmentList"
                                         :key="index">
                                        <div class="comList flex">
                                            <div class="flex">
                                                <div class="comList_img">
                                                    <img :src="items.image? items.image:require('../../assets/users.png')"
                                                         alt=""/>
                                                </div>
                                                <div class="comList_con">
                                                    <p class="con_title">{{items.title}}</p>
                                                    <p class="con_mess">
                                                        {{items.messages}}
                                                    </p>
                                                    <span> {{items.time}}</span>
                                                </div>
                                            </div>

                                            <div class="comList_star">
                                                <div class="comList_star_A flex">
                                                    <span>描述相符</span>
                                                    <el-rate v-model="items.designerStar" disabled
                                                             :colors="colors"></el-rate>
                                                </div>
                                                <div class="comList_star_A flex">
                                                    <span>服务态度</span>
                                                    <el-rate v-model="items.designerStar2" disabled
                                                             :colors="colors"></el-rate>
                                                </div>
                                                <div class="comList_star_A flex">
                                                    <span>专业程度</span>
                                                    <el-rate v-model="items.designerStar3" disabled
                                                             :colors="colors"></el-rate>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- 回复 -->
                                        <div v-if="items.reply" class="additional_evaluation">
                                            商家回复：{{items.reply}}
                                        </div>
                                    </div>
                                    <div style="text-align: right; padding: 0 0px 30px">
                                        <el-pagination
                                                background
                                                @current-change="handleCurrentChange"
                                                @prev-click="handleCurrentChange"
                                                @next-click="handleCurrentChange"
                                                layout="total,prev, pager, next,jumper"
                                                :current-page="current"
                                                :page-size="pageSize"
                                                :total="total" class="pagination">
                                        </el-pagination>
                                    </div>
                                </div>
                                <div v-else class="noMess" v-loading="loading">
                                    <img src="../../assets/noMesge.jpg" alt="" style="width:200px">
                                    <!-- <el-empty description="暂无评价"></el-empty> -->
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="成交记录" name="four">
                                <TransactionRecords ref="transactionRecordRef"></TransactionRecords>
                                <!-- <div class="noMess"  v-loading="loading">
                                  <img src="../../assets/noMesge.jpg" alt="" style="width:200px">
                                </div> -->
                            </el-tab-pane>
                            <!-- <el-tab-pane label="产品咨询" name="four">产品咨询</el-tab-pane> -->
                        </el-tabs>
                    </div>
                    <div class="recommended">
						<div style="background: #fff;margin-bottom: 20px;">
						<p class="recommendedtitle">店铺主页</p>
						<div class="goodsText">
						    <img :src="enterPriseInfo.logo ? enterPriseInfo.logo:require('../../assets/storeLogo.jpeg') " alt="" style="width:60px">
						    <p>{{ enterPriseInfo.name ? enterPriseInfo.name :''}}</p>
						</div>
						<div style="padding: 0 20px 16px 20px">
						    <el-button type="primary" plain
						               @click="goToDetail(storeInfo.enterpriseUuid)">进店逛逛
						    </el-button>
						    <el-button type="primary" plain @click="startChat(goodsInfo.createUserUuid)">立即联系
						    </el-button>
						</div>
						</div>
						<div style="background: #fff;height: auto;min-height: 700px;">
                        <p class="recommendedtitle">相关推荐</p>
                        <div class="recommendedbox"
                             v-for="(item,index) in recommendList"
                             :key="index"
                             @click="handGoodsDetails(item.uuid)"
                             v-if="recommendList.length>0">
                            <img :src="item.imgUrl" alt=""/>
                            <div class="recommendedText flex">
                                <div class="flex brandBox">
                                    <p class="brand" v-if="item.brand">{{ item.brand }}</p>
                                    <p>{{ item.name }}</p>
                                </div>
                                <p>{{ item.shopName }}</p>
                                <span class="red">¥{{ item.minPrice }}</span>
                            </div>
                        </div>
						</div>
                    </div>
                </div>
            </div>
        </div>
        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>
        <!-- 下架显示 -->
        <div class="shelves" v-if="goodsStatus!=='SHELVE'">
            <img src="../../assets/storeDown.png" alt="" />
            <p class="shelves_name">该商品已下架</p>
            <p class="shelves_time">
                <span>{{ second }}</span>
                <span>秒后返回商品列表</span>
            </p>
            <p class="shelves_click" @click="goToGoodsList">点击跳转商品列表</p>
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    import {mapState, mapMutations} from "vuex";
    import {videoPlayer} from 'vue-video-player';
    import "video.js/dist/video-js.css";
    import 'vue-video-player/src/custom-theme.css';
    import chatDialog from '../chat/chatDialog'

    // 成交记录
    import TransactionRecords from '../transactionRecords/transactionRecords'

    import {
        getShopList,
        getDictionaryItem,
        getGoodsDetail,
        getRelateRecommendList,
        getUserInfo,
        getNewcurrent,
        designerByUserId,
        saveVisitorLog,
        isCollection,
        saveServiceCollection,
        removeCollection,
        saveShopCar, getShopCarNumber,
        getEnterpriseCredentials,
        getEvaluationList,
        getTagsByGoodsId,
        activityInfo,
        isUserPointsIsEnough,
    } from '../../utils/interface';

    export default {
        name: "goodsDetails",
        components: {chatDialog, videoPlayer, TransactionRecords},
        data() {
            return {
                playerOptions: {
                    // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: false, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    // fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: "video/mp4",
                        // src: require('../../assets/测试.mp4'), //你的视频地址（必填）
                        src: '', //你的视频地址（必填）
                    }],
                    poster: "", //你的封面地址
                    width: document.documentElement.clientWidth,
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: false,
                        durationDisplay: false,
                        remainingTimeDisplay: false,
                        fullscreenToggle: true  //全屏按钮
                    }
                },
                listimg: [{
                    url: require("../../assets/0100.jpg")
                },
                    {
                        url: require("../../assets/0200.jpg")
                    },
                    {
                        url: require("../../assets/0100.jpg")
                    },
                    {
                        url: require("../../assets/0200.jpg")
                    },
                    {
                        url: require("../../assets/0400.jpg")
                    },
                    {
                        url: require("../../assets/0100.jpg")
                    },],


                value1: 3,
                value2: 5,
                changeBackground: 0,
                current: 1,
                config: {
                    url: window.location.href,
                    disabled: ['douban', 'linkedin', 'diandian', 'qq', 'qzone', 'tencent', 'google', 'twitter', 'tencent', 'weibo']
                },
                activeName: "one",
                bannerList: [
                    {
                        value: require("../../assets/image/zrcs.jpg"),
                    },
                ],
                searchInputValue: "",
                typeCheckValue: "one",
                buyNum: "1",
                searchValue: "",
                valueStare: 4,
                colors: ["#ff0000", "#ff0000", "#ff0000"],
                num: 1,
                collect: false,
                normsList: [],
                specUuid: "",
                goodsUuid: "",
                goodsInfo: {},
                enterPriseInfo: {},
                storeInfo: {},
                pcGoodsImages: [],
                pcGoodsVideos: [],
                urlInfo: "",
                logLogo: "",
                price: 0,
                goodsPrice: 0,
                recommendList: [],
                userMessages: {},
                totalNumber: 0,
                soldAmount: 0,
                volumeNum: 0,
                swiperIndex: 0,

                // 商家入驻信息
                identity: "",
                isService: false,
                collectUuid: "",
                // 类目属性
                categoryObj: {
                    specificationName: '规格名称',
                },
                keywords: [],
                isShow: false,
                goodsNum: 0,
                showAddCar: false,
                showAddGoods: false,
                sortBox: [],
                sortboxIndex: 0,
                colors: ["#da251d", "#da251d", "#da251d"],
                loading: true,
                conmmentList: [],
                current: 1,
                total: 0,
                pageSize: 5,
                form: {},
                prePath: '',
                second:5,
                timeout:"",
                goodsStatus:"SHELVE",
                activeUuid:'',
                activityType:'',
                activityStatus:'',
            };
        },
        computed: {
            ...mapState({
                isLogin: "isLogin",
                isUsermessage: "isUsermessage"
            }),
        },
        created() {
            // 商品主键
            this.goodsUuid = this.$route.query.goodUuid;
            this.activeUuid = this.$route.query.activeUuid;
            this.activityType = this.$route.query.activityType;
            getDictionaryItem({groupCode: 'shop_keyword'}).then((res) => {
                if (res != null && res.length > 0) {
                    res.forEach((item, index) => {
                        this.keywords.push(item.name);
                    });
                }
            });
            //
            this.getGoodsDetail();
            // 获取用户信息
            getNewcurrent().then((res) => {
                this.userMessages = res;
            })
                .catch((err) => {
                    console.log(err);
                });
            this.getShopCarNumber();
            this.commentList();
            // 倒计时
            this.timeout = setInterval(()=>{
                this.second--;
                if(this.second===0){
                    clearInterval(this.timeout);
                    if(this.goodsStatus!=='SHELVE'){
                        this.goToGoodsList();
                    }
                }
            },1000);
        },
        mounted() {
            // this.isServiceAuthentication();
        },
        methods: {
            goToGoodsList(){
                let routeData = this.$router.resolve({
                    name: "integralActivities",
                    params: { uuid: this.$route.query.activeUuid },
                });
                window.open(routeData.href, "_self");
            },
            ...mapMutations(["isLoginVuex"]),
            onBack() {
                this.$router.go(-1)
            },
            // 分页
            handleCurrentChange(val) {
                this.current = val
				window.scrollTo(0,0);
                this.commentList();
            },
            commentList() {
                if (this.sortBox.length > 1) {
                    this.form.tags = this.sortBox[this.sortboxIndex].id;
                }
                this.loading = true
                this.form.uuid = this.goodsUuid;
                this.form.orderType = 'SHOP';
                this.form.evaluationType = 'NORMAL';
                this.form.current = this.current;
                this.form.pageSize = this.pageSize;
                this.form.activityUuid = this.activeUuid;
                getEvaluationList(this.form).then((res) => {
                    console.log(res);
                    if (res != null && res.list != null && res.list.length > 0) {
                        this.total = res.total;
                        this.conmmentList = [];
                        if (this.sortBox.length == 0) {
                            this.sortBox.push({
                                name: '全部',
                                num: res.total
                            });
                        }
                        if (this.sortBox.length == 1) {
                            getTagsByGoodsId(this.form).then((res) => {
                                if (res != null && res.length > 0) {
                                    res.forEach((items, index) => {
                                        this.sortBox.push({
                                            id: items.tagUuid,
                                            name: items.tagName,
                                            num: items.evaluationNum,
                                        });
                                    });
                                }
                            });
                        }
                        res.list.forEach((item, index) => {
                            let evaluation = {};
                            evaluation.order = item;
                            evaluation.uuid = item.uuid;
                            evaluation.title = item.creator;
                            evaluation.messages = item.evaluationContent;
                            evaluation.designerStar = parseInt(item.descriptionPoint);
                            evaluation.designerStar2 = parseInt(item.servicePoint);
                            evaluation.designerStar3 = parseInt(item.transportPoint);
                            evaluation.time = item.createTime
                            evaluation.image = (item.iconUrl ? item.iconUrl : require('../../assets/designSrote/userLogo.jpeg'));

                            if (item.addedReplys != null && item.addedReplys.length > 0) {
                                item.addedReplys.some((item, index) => {
                                    if (item.evaluationType == 'REPLY') {
                                        evaluation.reply = item.evaluationContent;
                                        return true;
                                    }
                                });
                            }
                            this.conmmentList.push(evaluation);
                            this.loading = false
                            console.log(this.conmmentList);
                        });
                    } else {
                        this.total = 0;
                        this.loading = false
                    }
                });
            },
            getSortBox(index) {
                this.sortboxIndex = index;
                this.handleCurrentChange(1);
            },
            getShopCarNumber() {
                if (this.isLogin) {
                    this.isShow = true;
                    getShopCarNumber().then((res) => {
                        if (res.success) {
                            this.goodsNum = res.data;
                        }
                    })
                } else {
                    this.isShow = false;
                }
            },
            searchByKeyword(keyword) {
                this.searchValue = keyword;
                let routeData = this.$router.resolve({
                    name: "shopGoodsList",
                    query: {keywords: this.searchValue},
                });
                window.open(routeData.href, "_blank");// 新窗口打开外链接
            },
            getShopList() {
                let routeData = this.$router.resolve({
                    name: "shopGoodsList",
                    query: {keywords: this.searchValue},
                });
                window.open(routeData.href, "_blank");// 新窗口打开外链接
            },
            /*isServiceAuthentication() {
                if (this.isLogin) {
                    getNewcurrent().then((data) => {
                        // 1、设计师不显示
                        // 2、个人用户要进行企业认证
                        designerByUserId(data.uuid).then((res) => {
                            if (res == "") {
                                // 不是设计师
                                this.isService = true;
                            } else {
                                this.isService = false;
                            }
                        });
                    })
                }
            },*/
            // 商家入驻
            toServiceAuthentication() {
                if (this.$store.state.isLogin) {
                    getNewcurrent().then((data) => {
                        this.identity = data.identity;
                        if (this.identity === 'ENTERPRISE') {
                            this.$router.push({
                                name: "shopServiceAuthentication",
                            });
                        } else if (this.identity === 'PERSONAL' || this.identity === 'ANONYMOUS') {
                            this.$confirm('请先进行企业资质认证!', '提示', {
                                confirmButtonText: '去认证',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                window.sessionStorage.setItem("userServeId", "11");
                                let routeData = this.$router.resolve({
                                    name: "userCenter",
                                });
                                window.open(routeData.href, "_target");
                            });
                        }
                    });
                }
            },
            getGoodsDetail() {
                activityInfo(this.activeUuid).then((res1)=>{
                    if(res1.success && res1.data){
                        this.activityStatus = res1.data.activityProcess;
                        getGoodsDetail({uuid: this.goodsUuid, activityUuid: this.activeUuid}).then((res) => {
                            if (res.success) {
                                this.activityStatus = res1.data.activityProcess;
                                this.goodsStatus = res.data.info.status;
                                // 判断商品是否下架
                                /*if(res.data.info.status!=='SHELVE'){
                                    this.$confirm('该商品已下架！', '提示', {
                                        confirmButtonText: '确定',
                                        type: 'warning'
                                    }).then(() => {
                                        let routeData = this.$router.resolve({
                                            name: "shopGoodsList"
                                        });
                                        window.open(routeData.href, "_self");
                                    }).catch(() => {
                                        let routeData = this.$router.resolve({
                                            name: "shopGoodsList"
                                        });
                                        window.open(routeData.href, "_self");
                                    });
                                    return false;
                                }*/
                                this.goodsInfo = res.data.info;
                                this.normsList = this.goodsInfo.specificationsList;
                                if (this.normsList.length > 0) {
                                        this.price = this.normsList[0].price;
                                        this.goodsPrice = this.normsList[0].goodsPrice;
                                        this.activityType = this.normsList[0].activityType;
                                        this.totalNumber = this.normsList[0].amount - this.normsList[0].soldAmount;
                                        this.soldAmount = this.normsList[0].soldAmount;
                                        this.volumeNum = this.normsList[0].volumeNum;
                                        // 如果数量大于0
                                        if (this.totalNumber > 0) {
                                            this.num = 1;
                                            if(this.activityStatus == 'PROCESSING'){
                                                this.showAddGoods = false;
                                            }else {
                                                this.showAddGoods = true;
                                            }
                                        } else {
                                            this.num = 0;
                                            this.showAddCar = true;
                                            this.showAddGoods = true;
                                        }
                                        this.categoryObj = this.normsList[0];
                                        this.specUuid = this.normsList[0].uuid;
                                }
                                this.pcGoodsImages = this.goodsInfo.pcGoodsImages;
                                this.pcGoodsVideos = this.goodsInfo.pcGoodsVideos;
                                if (this.pcGoodsVideos.length > 0) {
                                    this.urlInfo = this.pcGoodsVideos[0].url;
                                    // 视频资源地址赋值
                                    this.playerOptions['sources'][0]['src'] = this.urlInfo;
                                }
                                if (this.pcGoodsImages.length > 0) {
                                    this.logLogo = this.pcGoodsImages[0].url;
                                }
                                this.enterPriseInfo = res.data.enterPriseInfo;
                                this.storeInfo = res.data.storeInfo;
                                getRelateRecommendList({
                                    storeTypeUuid: this.goodsInfo.storeTypeUuid,
                                    status: "SHELVE",
                                    goodsUuid: this.goodsInfo.uuid
                                }).then((res) => {
                                    this.recommendList = res.data;
                                });
                                this.saveVisitorLog();
                                this.isCollectInfo();
                            }
                        });
                    }else {
                        this.$message({
                            type: "error",
                            message: "活动数据异常， 无法完成当前商品兑换！",
                        });
                    }
                });
            },

            swiperChange(index) {
                this.swiperIndex = index;
                if (index != 0 && this.$refs.videoPlayer) {
                    this.$refs.videoPlayer.player.pause()
                }
                if (index > 3) {
                    let scrollbarEl = this.$refs.thumbnailImgRef.wrap;
                    scrollbarEl.scrollLeft = index * 190
                }
            },
            thumbnailImgChange(index, i, url) {
                this.swiperIndex = index;
                //封面
                // this.playerOptions.poster = url;
                if (index > 3) {
                    let scrollbarEl = this.$refs.thumbnailImgRef.wrap;
                    scrollbarEl.scrollLeft = index * 190
                }
                // if (i === 3) {
                //   this.playerOptions.sources[0].src = url;
                // }
                this.$refs.carouselRef.setActiveItem(index)
            },
            saveCollect() {
                // 如果为当前登录用户的商品则不允许收藏
                // 获取当前用户信息
                if (this.isLogin) {
                    if (this.goodsInfo.createUserUuid == this.userMessages.uuid) {
                        this.$message.error('无法收藏自己的商品');
                        return false;
                    }
                    // 收藏商品
                    let params = {
                        serviceabilityUuid: this.goodsInfo.uuid,
                        type: 1
                    };
                    saveServiceCollection(params).then((res) => {
                        if (res.success) {
                            this.$message.success('收藏成功!');
                            this.collectUuid = res.data.uuid;
                            this.goodsInfo.collectionVolume++;
                            this.isCollectInfo();
                        }
                    });
                } else {
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push('/login')
                }
            },
            isCollectInfo() {
                let params = {
                    serviceabilityUuid: this.goodsInfo.uuid
                };
                isCollection(params).then((res) => {
                    if (res && res.data != null) {
                        this.collect = true;
                        this.collectUuid = res.data.uuid;
                    } else {
                        this.collect = false;
                    }
                });
            },
            removeCollect() {
                // 收藏商品
                let params = {
                    uuid: this.collectUuid
                };
                removeCollection(params).then((res) => {
                    if (res.success) {
                        this.$message.success('取消成功!');
                        this.collectUuid = "";
                        this.goodsInfo.collectionVolume--;
                        this.isCollectInfo();
                    }
                });
            },
            saveVisitorLog() {
                let param = {
                    title: this.goodsInfo.name,
                    logo: this.logLogo,
                    visitorType: 'GOODS',
                    price: this.price,
                    link: window.location.href
                };
                saveVisitorLog(param);
            },
            changeUrl(url) {
                this.urlInfo = url;
            },
            handleClick(tab, event) {
                console.log(tab.index, event);
                if (tab.index == 3) {
                    this.$refs.transactionRecordRef.init(this.goodsUuid, "INTEGRAL", "", "", this.activeUuid);
                }
            },
            handleChange(value) {
                console.log(value);
            },
            // 商品详情
            handGoodsDetails(uuid) {
                let routeData = this.$router.resolve({
                    name: "shopGoodDetails",
                    params: {uuid: uuid},
                });
                window.open(routeData.href, "_blank");
            },
            //选择规格
            change(index, item) {
                    this.changeBackground = index;
                    this.totalNumber = item.amount - item.soldAmount;
                    this.soldAmount = item.soldAmount;
                    this.volumeNum = item.volumeNum;
                    this.price = item.price;
                    this.goodsPrice = item.goodsPrice;
                    this.activityType = item.activityType;
                    this.categoryObj = item;
                    this.specUuid = item.uuid;
                    // 如果数量大于0
                    if (this.totalNumber > 0) {
                        this.num = 1;
                        if(this.activityStatus == 'PROCESSING'){
                            this.showAddCar = false;
                            this.showAddGoods = false;
                        }else {
                            this.showAddCar = true;
                            this.showAddGoods = true;
                        }
                    } else {
                        this.num = 0;
                        this.showAddCar = true;
                        this.showAddGoods = true;
                    }
                    // 选定数据
                    this.thumbnailImgChange(this.pcGoodsImages.length + index);

            },
            creatQrCode() {
                // console.log(window.location.href);
                var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                    text: window.location.href, // 需要转换为二维码的内容
                    width: 200,
                    height: 200,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                })
            },
            startChat(targetUserId) {
                if (this.isLogin) {
                    let user = this.$store.state.isUsermessage;
                    if (targetUserId == this.userMessages.uuid) {
                        this.$message.error('检测当前联系店铺与您处于同一企业，暂不支持联系!');
                        return false;
                    } else {
                        getUserInfo(targetUserId).then(res => {
                            console.log('targetUserId-------' + targetUserId);
                            console.log(res);
                            this.$refs.chatDialogRef.init(user.uuid, user.name, user.headUrl, targetUserId, res.name, res.headUrl);
                        });
                    }
                } else {
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push('/login')
                }
            },
            // 添加购物车
            addShopCar() {
                if (this.isLogin) {
                    // 查询是否为当前用户的商品
                    let user = this.$store.state.isUsermessage;
                    console.log(user);
                    if (user.identity === "ENTERPRISE") {
                        if (this.goodsInfo.createUserUuid === user.uuid) {
                            this.$message.error("不能添加自己店铺的商品");
                            return false;
                        } else {
                            this.addShopCarGoodsInfo();
                        }
                        /*getEnterpriseCredentials().then((res)=>{
                          if(this.enterPriseInfo.enterPriseId===res.data.enterpriseTypeUuid){
                            this.$message.error("无法添加自己的商品");
                            return false;
                          }else{
                            this.addShopCarGoodsInfo();
                          }
                        });*/
                    } else {
                        this.addShopCarGoodsInfo();
                    }
                } else {
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push('/login')
                }
            },
            addShopCarGoodsInfo() {
                let params = {
                    storeUuid: this.goodsInfo.storeId,
                    enterPriseUuid: this.storeInfo.enterpriseUuid,
                    shopCarList: [{
                        price: this.price,
                        num: this.num,
                        storeUuid: this.goodsInfo.storeId,
                        goodsSpecUuid: this.specUuid,
                        goodsUuid: this.goodsInfo.uuid
                    }]
                };
                saveShopCar(params).then((res) => {
                    if (res.success) {
                        this.$message.success("添加成功");
                        this.getShopCarNumber();
                    }
                });
            },
            // 立即购买
            rightBuy(uuid,brand) {
                if (this.isLogin) {
                    // 查询是否为当前用户的商品
                    let user = this.$store.state.isUsermessage;
                    if (user.identity === "ENTERPRISE") {
                        /*getEnterpriseCredentials().then((res)=>{
                          if(user.uuid===res.data.userUuid){
                            this.$message.error("无法添加自己的商品");
                            return false;
                          }else{
                            this.buyGoodsInfo(uuid);
                          }
                        });*/
                        if (this.goodsInfo.createUserUuid === user.uuid) {
                            this.$message.error("不能购买自己店铺的商品");
                            return false;
                        } else {
                            let params = {
                                goodsSpecUuid: this.specUuid,
                                activityUuid: this.activeUuid
                            };
                            isUserPointsIsEnough(params).then((res) => {
                                if (res.success) {
                                    this.buyGoodsInfo(uuid,brand);
                                } else {
                                    this.$message({
                                        type: "error",
                                        message: res.message,
                                    });
                                }
                            });
                        }
                    } else {
                        let params = {
                            goodsSpecUuid: this.specUuid,
                            activityUuid: this.activeUuid
                        };
                        isUserPointsIsEnough(params).then((res) => {
                            if (res.success) {
                                this.buyGoodsInfo(uuid,brand);
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message,
                                });
                            }
                        });
                    }
                } else {
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push('/login')
                }
            },
            buyGoodsInfo(uuid,brand) {
                let updateForm = [{
                    goodsUuid: uuid,
                    brand: brand,
                    activityUuid: this.activeUuid,
                    activityType: this.activityType,
                    goodsNum: this.num,
                    goodsSpecUuid: this.specUuid
                }];
                window.sessionStorage.removeItem("updateForm");
                window.sessionStorage.setItem("updateForm", JSON.stringify(updateForm));
                let routeData = this.$router.resolve({
                    name: "activeShopAffirmOrder",
                });
                window.open(routeData.href, "_blank");
            },
            // 进店看看
            goToDetail(enterpriseUuid) {
                // uuid 店铺信息
                // enterPriseUuid 企业id
                // 跳转到详情页
                let routeData = this.$router.resolve({
                    name: "printServiceIndex",
                    params: {enterPriseId: enterpriseUuid},
                });
                window.open(routeData.href, "_blank");
            },
        },
    };
</script>

<style scoped lang="less">
    @import "../../assets/dist/css/share.min.css";

    .left_top_share {
        position: absolute;
        display: flex;
        align-items: center;
        right: 0;
        top: 15px;
        padding: 0 10px 0 20px;
        font-size: 16px;

        .shareHover:hover {
            z-index: 99999;
        }

        p {
            padding-right: 20px;
            color: #c9c9c9;
            display: flex;
            justify-items: center;

            i {
                font-size: 22px;
                cursor: pointer;
                padding-right: 10px;
            }
        }
    }

    .red {
        color: #da251d;
    }

    .container {
        width: 1200px;
        margin: 0 auto;

        .containerStyleClass {
            box-sizing: border-box;
            margin: 0 !important;

            .containerLeftTop {
                background: #fff;
                padding: 15px;
                box-sizing: border-box;
                display: flex;
                position: relative;

                .softwareLogo {
                    width: 670px;
                    margin-right: 30px;

                    /deep/ .el-carousel__indicators--horizontal {
                        display: none;
                    }

                    /deep/ .el-carousel--horizontal {
                        z-index: 0;
                    }

                    /deep/ #vjs_video_3 {
                        height: 375px;
                    }

                    .goodsVideo {
                        // display: none;
                        width: 586px;
                        height: 375px;
                    }

                    .bigImg {
                        position: relative;

                        .videoImg {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);

                            img {
                                width: 80px;
                                // background-color: white;
                            }
                        }
                    }


                    .goodsImgs {
                        // border-bottom: 1px solid #efefef;
                        display: flex;
                        margin-top: 5px;

                        /deep/ .el-scrollbar__view {
                            width: 586px;
                            border-bottom: 1px solid #ddd;
                        }

                        /deep/ .el-scrollbar__wrap {
                            overflow: scroll;
                            // height: 100%;
                            overflow-x: hidden;
                        }

                        ul {
                            display: flex;
                            border-bottom: 1px solid #ddd;
                            padding-bottom: 10px;
                            width: fit-content;

                            li {
                                // min-width: 175px;
                                // width: 75px;
                                // height: 98px;
                                background: #FFFFFF;
                                border-radius: 4px;
                                margin-right: 9px;
                                cursor: pointer;
                                position: relative;

                                &.active {
                                    &:before {
                                        content: '';
                                        position: absolute;
                                        bottom: -12px;
                                        left: 0;
                                        width: 140px;
                                        height: 2px;
                                        background: #009999;
                                    }
                                }
                            }
                        }

                        /deep/ .el-image {
                            margin-left: 10px;
                            border-bottom: 2px solid #009999;
                            padding-bottom: 10px;
                        }

                        /deep/ .el-image:nth-of-type(1) {
                            margin-left: 0;
                        }
                    }
                }

                .softwareRight {
                    width: 720px;

                    .topServBoxInfo {
                        h3 {
                            font-family: "Roboto Slab", Helvetica, Arial, sans-serif;
                            font-weight: 400;
                            font-size: 18px;
                            margin-bottom: 20px;
                            color: #333333;
							width: 420px;
                        }
                    }

                    .topServBoxMess {
                        margin-bottom: 20px;
                        font-size: 24px;
                        font-weight: 500;
                        align-items: flex-end;

                        p {
                            font-size: 18px;
                            margin-bottom: 2px;
                        }

                        .topServBoxMesscolor {
                            font-size: 14px;
                            font-weight: 400;
                            color: #333333;
                        }
                    }

                    .goodsBests {
                        margin-bottom: 20px;

                        .goodsListbox {
                            align-items: center;
                            width: 100%;
                            flex-wrap: wrap;
                            justify-content: space-between;
                        }

                        .normsList1 {
                            width: 48%;
                            display: flex;
                            align-items: center;
                            margin-bottom: 10px;
                            border: 1px solid red;
                            padding: 5px 5px;
                            box-sizing: border-box;

                            img {
                                vertical-align: middle;
                            }

                            span {
                                margin-left: 20px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }

                        .normsList {
                            width: 48%;
                            display: flex;
                            align-items: center;
                            margin-bottom: 10px;
                            border: 1px solid #C0C4CC;
                            padding: 5px 5px;
                            box-sizing: border-box;
                            cursor: pointer;

                            img {
                                vertical-align: middle;
                            }

                            span {
                                margin-left: 20px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }

                        p {
                            font-size: 14px;
                            font-weight: 400;
                            color: #333333;
                            width: 75px;
                            flex-shrink: 0;
                            margin-right: 20px;
                            line-height: 43px;

                        }

                        span {
                            font-size: 14px;
                            font-weight: 400;
                            color: #333333;
                        }
                    }

                    .goodsBest {
                        align-items: center;
                        margin-bottom: 20px;

                        .normsList {
                            display: flex;
                            flex-wrap: wrap;

                        }

                        p {
                            font-size: 14px;
                            font-weight: 400;
                            color: #333333;
                            width: 80px;
                            margin-right: 20px;
                            white-space: nowrap;
                        }

                        span {
                            font-size: 14px;
                            font-weight: 400;
                            color: #333333;
                        }
                    }

                    .goodsButton {
                        /deep/ .el-button {
                            height: 44px;
                            // width: 155px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        /deep/ .el-icon-shopping-cart-1 {
                            font-size: 22px;
                        }

                        /deep/ .el-button + .el-button {
                            margin-left: 20px;
                        }
                    }

                    .goodsText {
                        display: flex;
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                        padding-top: 20px;
                        margin-top: 30px;
                        border-top: 1px solid #efefef;
                        align-items: center;
                        margin-bottom: 20px;

                        img {
                            vertical-align: middle;
                            width: 50px;
                            height: 31px;
                        }

                        p {

                            margin-left: 10px;
                        }
                    }
                }
            }

            .bottonMessage {
                margin-top: 10px;
                box-sizing: border-box;
                justify-content: space-between;

                .containerLeftBottom {
                    width: 885px;

                    .bottomMessage {
                        font-size: 15px;
                        color: #666;

                        .vHtmlMess {
                            white-space: pre-wrap;

                            /deep/ img {
                                max-width: 100% !important;
                            }

                            /deep/ table {
                                border: none;
                                border-collapse: collapse;
                            }

                            /deep/ table td,
                            /deep/ table th {
                                border: 1px solid #ccc;
                                padding: 3px 5px;
                                min-width: 50px;
                                height: 20px;
                            }

                            /deep/ table th {
                                border-right: 1px solid #ccc;
                                border-bottom: 2px solid #ccc;
                                text-align: center;
                                background-color: #f1f1f1;
                            }
                        }
                    }

                    /deep/ .el-tabs {
                        background: #fff;
                    }

                    /deep/ .el-tabs__content {
                        padding: 20px 30px;
                    }

                    /deep/ .el-tabs__header {
                        margin: 0;
                    }

                    /deep/ .el-tabs__nav {
                        height: 48px;
                        line-height: 48px;
                    }

                    /deep/ .el-tabs__item {
                        padding: 0 16px;
                        // margin-right: 24px;
                    }

                    .category {
                        .category_box {
                            font-size: 13px;
                            color: #777;

                            .categoryName {
                                display: flex;
                                align-items: center;
                                margin-bottom: 30px;
                            }

                            .categoryMess {
                                display: flex;
                                align-items: center;
                                flex-wrap: wrap;

                                .categoryMess_text {
                                    display: flex;
                                    align-items: center;
                                    margin-bottom: 10px;
                                    width: 33%;

                                    p {
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                        margin-right: 10px;
                                    }
                                }
                            }

                            .categoryData {
                                margin-bottom: 20px;
                            }
                        }
                    }

                    .noMess {
                        color: #666;
                        font-size: 14px;
                        text-align: center;
                    }


                    .right_sortbox {
                        font-size: 14px;
                        height: 32px;
                        line-height: 32px;
                        margin-bottom: 28px;
                        flex-wrap: wrap;
                        // margin-top: 20px;
                        .p_active {
                            color: #009999;
                            background: #f3f8ff;
                            border-radius: 8px;
                        }

                        p {
                            cursor: pointer;
                            padding: 0 10px;
                            margin-right: 20px;
                        }
                    }

                    .comList {
                        border-radius: 10px;
                        width: 100%;
                        padding: 15px 0;
                        box-sizing: border-box;
                        -moz-box-sizing: border-box; /* Firefox */
                        -webkit-box-sizing: border-box; /* Safari */
                        margin-top: 15px;
                        justify-content: space-between;

                        .comList_img {
                            width: 55px;
                            height: 55px;
                            background: #efefef;
                            border-radius: 50%;
                            margin-right: 15px;

                            img {
                                width: 55px;
                                height: 55px;
                                border-radius: 50%;
                            }
                        }

                        .comList_con {
                            color: #777;
                            margin-right: 10px;

                            .con_title {
                                font-size: 14px;
                                margin-bottom: 5px;
                                color: #262626;
                            }

                            .con_mess {
                                font-size: 14px;
                                color: #262626;
                            }

                            span {
                                color: #B8B8B8;
                                font-size: 12px;
                            }
                        }

                        .comList_star {
                            flex-shrink: 0;

                            .comList_star_A {
                                align-content: center;
                                margin-bottom: 3px;

                                span {
                                    color: #B8B8B8;
                                    font-size: 13px;
                                    margin-right: 5px;
                                    line-height: 22px;
                                }
                            }
                        }
                    }

                }

                .recommended {
                    // background: #fff;
                    width: 300px;

                    .recommendedtitle {
                        width: 96px;
                        box-sizing: border-box;
                        color: #099;
                        font-size: 16px;
                        padding: 12px 16px 10px;
                        border-bottom: 2px solid #099;
                    }
					.goodsText {
					    display: flex;
					    font-size: 14px;
					    font-weight: 400;
					    color: #333333;
					   padding: 20px 20px;
					    align-items: center;
					    margin-bottom: 20px;

					    img {
					        vertical-align: middle;
					        width: 50px;
					        height: 31px;
					    }

					    p {

					        margin-left: 10px;
					    }
					}
                    .recommendedbox {
                        width: 275px;
                        margin: 0 auto;
                        padding-bottom: 20px;

                        img {
                            width: 275px;
                            // height: 210px;
                            background: #efefef;
                            margin: 20px 0 10px;
                        }

                        .recommendedText {
                            justify-content: space-between;
                            display: flex;

                            p {
                                font-size: 14px;
                                font-weight: 400;
                                color: #333333;
                                // width: 210px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }

                            span {
                                font-size: 14px;
                                font-weight: 500;
                            }
                            .brandBox {
                                align-items: center;
                                width: 210px;
                            }
                        }
                    }
                }
            }

            .relatedRecommendation {
                box-sizing: border-box;
                background: #fff;
                padding: 15px 0;

                .recommendationTop {
                    margin: 0 auto;
                    background: #efefef;
                    width: 100px;
                    height: 100px;

                    img {
                        width: 100px;
                        height: 100px;
                    }
                }

                .recommendationTopMess {
                    text-align: center;

                    h4 {
                        margin: 10px 0;
                    }

                    p {
                        font-size: 14px;
                        color: #777;
                        margin-bottom: 10px;
                    }
                }

                .printTitle {
                    padding: 15px;
                    text-align: left;
                    box-sizing: border-box;
                    border-bottom: 1px solid #eee;
                    color: #009999;
                    margin: 0;
                    font-size: 16px;
                    font-weight: 600;
                    justify-content: space-between;
                    align-items: flex-end;
                    padding-top: 0;

                    p {
                        font-size: 14px;
                        font-weight: normal;
                        color: #777;

                        i {
                            font-weight: bold;
                            color: #000;
                        }
                    }
                }

                ul {
                    li {
                        padding-top: 10px;
                        border-bottom: 1px dashed #eee;
                        text-align: center;
                        margin-bottom: 0;
                    }
                }

                .hotRecommendation {
                    padding: 10px;
                    border-bottom: 1px solid #efefef;

                    .newRightBox {
                        justify-content: space-between;

                        .newRightBoximg {
                            width: 120px;
                            height: 60px;
                            background: #efefef;
                            cursor: pointer;
                            flex-shrink: 0;

                            img {
                                width: 100%;
                            }
                        }

                        .newRightBoxMess {
                            margin-left: 10px;
                            font-size: 14px;

                            h4 {
                                cursor: pointer;
                            }

                            h4:hover {
                                color: #009999;
                            }

                            p {
                                font-size: 12px;
                            }

                            p:nth-of-type(1) {
                                color: #666;
                                margin: 10px 0;
                            }

                            p:nth-of-type(2) {
                                color: #555;
                            }
                        }
                    }

                    .newRight {
                        color: #999;
                        margin-top: 15px;
                        font-size: 12px;

                        .newRightColor2 {
                            margin-left: 20px;
                        }
                    }
                }
            }
        }
    }

    .printTitle {
        font-size: 28px;
        font-weight: normal;
        color: #009999;
        margin-top: 60px;
        margin-bottom: 30px;
        border-bottom: 1px solid #e3e3e3;
        padding-bottom: 10px;

        span.tit {
            padding-bottom: 10px;
            border-bottom: 1px solid #009999;
        }

        span.more {
            font-size: 16px;
            float: right;
            margin-top: 10px;
        }

        .more i {
            color: #505050 !important;
        }
    }

    .softMarketTop {
        width: 100%;
        // height: 110px;
        background: #fff;
        box-sizing: border-box;

        .softMarketTopSearch {
            width: 1200px;
            margin: 0 auto;
            height: 100%;
            display: flex;
            padding-top: 18px;
            // padding-bottom: 18px;
            box-sizing: border-box;

            .logoTitle {
                font-size: 24px;
                // line-height: 74px;
                color: #009999;
                font-weight: bold;

                .logoTitle1 {
                    height: 40px;
                    color: #000;
                }

                .logoTitle2 {
                    font-size: 18px;
                    background: #000;
                    height: 40px;
                    color: #fff;
                    line-height: 40px;
                    width: 246px;
                    padding-left: 20px;
                    box-sizing: border-box;
                    margin-top: 6px;
                    font-weight: 400;
                }
            }

            .shoppingCar {
                margin-top: 9px;
            }

            .searchContainer {
                // width: 690px;
                margin: 0 auto;
                padding: 0 15px;

                .searchContainerone {
                    .input-with-select {
                        flex-shrink: 0;
                    }

                    .searchContainerButton {
                        color: #009999;
                        margin-left: 60px;
                        border: 1px solid #009999;
                        background: #fff;
                        font-size: 14px;
                    }
                }

                /deep/ .input-with-select .el-input__inner {
                    border: 2px solid #009999;
                    border-top-left-radius: 20px;
                    border-bottom-left-radius: 20px;
                    background: #fdfdfd;
                    height: 40px;
                    line-height: 40px;
                }

                /deep/ .el-input-group {
                    height: 40px;
                    width: 618px;
                }

                /deep/ .input-with-select .el-input-group__append {
                    background: #009999;
                    color: #fff;
                    border: 1px solid #009999;
                    border-left: none;
                    border-radius: 0px 20px 20px 0px;
                    width: 80px;
                    box-sizing: border-box;
                    text-align: center;
                }

                ul {
                    display: flex;
                    color: #c0c0c0;
                    padding-left: 3px;

                    li {
                        font-size: 12px;
                        margin-top: 10px;
                        padding: 0 15px;

                        &.textLi {
                            border-right: 1px solid #6E6E6E;
                            cursor: pointer;

                            &:hover {
                                color: #009999;
                            }
                        }
                        &.textLi:last-child{
                            border: none !important;
                        }
                    }
                }
            }
        }
    }
    .shelves {
        text-align: center;
        img {
            width: 406px;
        }
        .shelves_name {
            margin-top: 30px;
            font-size: 18px;
            color: rgb(187, 187, 187);
        }
        .shelves_time {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: #666;
            margin-top: 70px;
            span:nth-of-type(1) {
                margin-right: 5px;
                color: #009999;
            }
        }
        .shelves_click {
            margin-top: 10px;
            margin-bottom: 80px;
            font-size: 14px;
            color: #009999;
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/integral/shopGoodDetails.vue